<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fmtitle"><span class="bold">A Mostly Somewhat Putative Chronology</span></h2>
<p class="noindentb">All dates are BCE unless otherwise stated.</p>
<p class="list"><span class="list">1150</span> Fall of Troy</p>
<p class="list"><span class="list">753</span> Romulus founds Rome</p>
<p class="list"><span class="list">716</span> Death of Romulus; accession of Numa Pompilius</p>
<p class="list"><span class="list">673</span> Death of Numa Pompilius; accession of Tullus Hostilius</p>
<p class="list"><span class="list">642</span> Death of Tullus Hostilius; accession of Ancus Marcius</p>
<p class="list"><span class="list">617</span> Death of Ancus Marcius; accession of Tarquinius Priscus</p>
<p class="list"><span class="list">579</span> Death of Tarquinius Priscus; accession of Servius Tullius</p>
<p class="list"><span class="list">535</span> Death of Servius Tullius; accession of Tarquin the Proud</p>
<p class="list"><span class="list">509</span> Tarquin the Proud is expelled from Rome; Brutus establishes the Republic</p>
<p class="list"><span class="list">508</span> Mucius Scaevola attempts to kill Lars Porsena, king of Clusium; Cloelia swims to safety</p>
<p class="list"><span class="list">493</span> Coriolanus defeats the Volscians</p>
<p class="list"><span class="list">458</span> Cincinnatus is appointed dictator</p>
<p class="list"><span class="list">449</span> Appius Claudius lusts after Verginia</p>
<p class="list"><span class="list">396</span> Veii is destroyed</p>
<p class="list"><span class="list">394</span> Camillus rejects an offer from the Falerian schoolteacher</p>
<p class="list"><span class="list">387</span> The Romans are defeated at the Battle of the Allia; the Gauls sack Rome</p>
<p class="list"><span class="list">384</span> Marcus Manlius is thrown from the Tarpeian Rock</p>
<p class="list"><span class="list">340</span> Decius Mus sacrifices himself to the spirits of the dead</p>
<p class="list"><span class="list">321</span> The Battle of the Caudine Forks</p>
<p class="list"><span class="list">279</span> Pyrrhus wins a pyrrhic victory</p>
<p class="list"><span class="list">249</span> Publius Claudius Pulcher fails to heed the warning from the sacred chickens and loses the Battle of Drepana</p>
<p class="list"><span class="list">218</span> Hannibal crosses the Alps</p>
<p class="list"><span class="list">216</span> Hannibal defeats the Romans at the Battle of Cannae</p>
<a id="page_vii"></a>
<p class="list"><span class="list">204</span> The Great Mother arrives in Rome</p>
<p class="list"><span class="list">202</span> Hannibal is defeated at the Battle of Zama</p>
<p class="list"><span class="list">172</span> Antiochus IV Epiphanes is humiliated</p>
<p class="list"><span class="list">146</span> Carthage is destroyed</p>
<p class="list"><span class="list">133</span> Assassination of Tiberius Gracchus</p>
<p class="list"><span class="list">121</span> Assassination of Gaius Gracchus</p>
<p class="list"><span class="list">107</span> Marius reforms the Roman army</p>
<p class="list"><span class="list">81</span> Sulla becomes dictator</p>
<p class="list"><span class="list">73–1</span> Revolt of Spartacus</p>
<p class="list"><span class="list">49</span> Julius Caesar crosses the Rubicon</p>
<p class="list"><span class="list">44</span> Julius Caesar is assassinated</p>
<p class="list"><span class="list">27</span> Octavian becomes Augustus</p>
<p class="list"><span class="list">CE 410</span> Alaric the Goth sacks Rome</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Chronology.vue?567fcba7